import {createReducer} from 'redux-act';
import {
  CANCEL_DELIVERY_ORDER,
  CHANGE_STATUS,
  CHANGE_STATUS_SUCCESS,
  CLEAR_ORDER,
  DELETE_DRIVER_RATING,
  DELETE_DRIVER_RATING_ERROR,
  DELETE_DRIVER_RATING_SUCCESS,
  GET_DELIVERY_STATUS,
  GET_DELIVERY_STATUS_SUCCESS,
  GET_DISPATCH_INFO,
  GET_DISPATCH_INFO_SUCCESS,
  GET_DRIVER_RATING,
  GET_DRIVER_RATING_ERROR,
  GET_DRIVER_RATING_SUCCESS,
  GET_ORDER,
  GET_ORDER_SUCCESS,
  OPEN_CANCEL_DELIVERY_ORDER_MODAL,
  OPEN_CANCEL_DELIVERY_ORDER_RESULT_MODAL,
  ORDER_UNMOUNT,
  SET_ORDER_LOADING,
  RATE_DRIVER,
  RATE_DRIVER_ERROR,
  RATE_DRIVER_SUCCESS,
  SET_DELIVERY_STATUS_LOADING,
  SET_LOADING,
  SET_LOADING_CANCELLATION,
  GET_BAD_ORDERS_BY_CORE,
  SET_BAD_ORDERS_BY_CORE,
  UPDATE_DRIVER_RATING,
  UPDATE_DRIVER_RATING_ERROR,
  UPDATE_DRIVER_RATING_SUCCESS
} from 'store/ordersV2/orderDetails/action';
import {ORDER} from 'helpers/constants/orders_v2';
import {calculateOverdueAndFuture} from 'helpers/functionUtils/ordersUtilsV2';

const initialState = () => ({
  order: {
    orderInfo: {
      items: []
    }
  },
  dispatchInfo: null,
  locationData: null,
  ordersLoading: false,
  changeStatusLoading: null,
  deliveryStatus: {
    status: null,
    lastUpdateDate: null,
    courier: {deliveryServiceProvider: null, name: null, vehicle: null},
    dispatchOrderId: null,
    dispatchVersion: null,
    dspOrderId: null,
    proofOfDelivery: null
  },
  isOpenCancelDeliveryOrderModal: false,
  loadingCancellation: false,
  deliveryCancellationResult: {
    isOpenModal: false,
    message: null
  },
  rateDriverLoading: false,
  rateDriverError: null,
  driverRating: null,
  getDriverRatingLoading: false,
  updateDriverRatingLoading: false,
  deleteDriverRatingLoading: false,
  deliveryStatusLoading: false,
  badOrders: [],
  badOrdersLoading: false
});

const orderDetailsV2Reducer = createReducer(
  {
    [CHANGE_STATUS]: (state) => ({
      ...state,
      changeStatusLoading: true
    }),
    [CHANGE_STATUS_SUCCESS]: (state, payload) => ({
      ...state,
      order: {...state.order, [ORDER.ORDER_STATUS]: payload},
      changeStatusLoading: false
    }),
    [GET_ORDER]: (state, payload) => ({
      ...state,
      loading: !payload?.silent,
      badOrders: [],
      badOrdersLoading: false
    }),
    [SET_ORDER_LOADING]: (state, payload) => ({
      ...state,
      loading: payload
    }),
    [ORDER_UNMOUNT]: (state) => ({
      ...state,
      ...initialState(),
      currentLocationTimezone: state.currentLocationTimezone
    }),
    [GET_ORDER_SUCCESS]: (state, payload) => {
      return {
        ...state,
        order: calculateOverdueAndFuture(
          payload?.order,
          payload?.PickupReadyEnabled,
          payload?.serviceFeatures
        ),
        loading: false
      };
    },
    [GET_DISPATCH_INFO]: (state) => ({
      ...state
    }),
    [GET_DISPATCH_INFO_SUCCESS]: (state, {support_number, order_id}) => {
      const info = {};
      info.DeliverySupportPhoneNumber = support_number;
      info.DeliveryReferenceNumber = order_id;
      return {
        ...state,
        dispatchInfo: info
      };
    },
    [GET_DELIVERY_STATUS]: (state) => {
      return {
        ...state,
        deliveryStatusLoading: true
      };
    },
    [GET_DELIVERY_STATUS_SUCCESS]: (state, payload) => ({
      ...state,
      deliveryStatus: payload,
      deliveryStatusLoading: false
    }),
    [SET_DELIVERY_STATUS_LOADING]: (state, payload) => ({
      ...state,
      deliveryStatusLoading: payload
    }),
    [OPEN_CANCEL_DELIVERY_ORDER_MODAL]: (state, payload) => ({
      ...state,
      isOpenCancelDeliveryOrderModal: payload
    }),
    [SET_LOADING_CANCELLATION]: (state, payload) => ({
      ...state,
      loadingCancellation: payload
    }),
    [CANCEL_DELIVERY_ORDER]: (state) => ({
      ...state,
      loadingCancellation: true
    }),
    [OPEN_CANCEL_DELIVERY_ORDER_RESULT_MODAL]: (state, payload) => ({
      ...state,
      deliveryCancellationResult: payload,
      loadingCancellation: false
    }),
    [RATE_DRIVER]: (state) => ({
      ...state,
      rateDriverLoading: true,
      rateDriverError: null
    }),
    [RATE_DRIVER_SUCCESS]: (state, payload) => ({
      ...state,
      rateDriverLoading: false,
      rateDriverError: null,
      driverRating: payload
    }),
    [RATE_DRIVER_ERROR]: (state, payload) => ({
      ...state,
      rateDriverLoading: false,
      rateDriverError: payload
    }),
    [GET_DRIVER_RATING]: (state) => ({
      ...state,
      getDriverRatingLoading: true
    }),
    [GET_DRIVER_RATING_SUCCESS]: (state, payload) => ({
      ...state,
      driverRating: payload,
      getDriverRatingLoading: false
    }),
    [GET_DRIVER_RATING_ERROR]: (state) => ({
      ...state,
      getDriverRatingLoading: false
    }),
    [UPDATE_DRIVER_RATING]: (state) => ({
      ...state,
      updateDriverRatingLoading: true
    }),
    [UPDATE_DRIVER_RATING_SUCCESS]: (state, payload) => ({
      ...state,
      driverRating: payload,
      updateDriverRatingLoading: false
    }),
    [UPDATE_DRIVER_RATING_ERROR]: (state) => ({
      ...state,
      updateDriverRatingLoading: false
    }),
    [DELETE_DRIVER_RATING]: (state) => ({
      ...state,
      deleteDriverRatingLoading: true
    }),
    [DELETE_DRIVER_RATING_SUCCESS]: (state) => ({
      ...state,
      driverRating: null,
      deleteDriverRatingLoading: false
    }),
    [DELETE_DRIVER_RATING_ERROR]: (state) => ({
      ...state,
      deleteDriverRatingLoading: false
    }),
    [GET_BAD_ORDERS_BY_CORE]: (state) => ({
      ...state,
      badOrdersLoading: true
    }),
    [SET_BAD_ORDERS_BY_CORE]: (state, payload) => ({
      ...state,
      badOrders: Array.isArray(payload) ? payload : [],
      badOrdersLoading: false
    }),
    [CLEAR_ORDER]: () => ({
      ...initialState()
    })
  },
  initialState()
);

export default orderDetailsV2Reducer;
